import {createSlice} from "@reduxjs/toolkit";
import {setUIRestrictionSearchFilter} from "./actions";
import {RestrictionSearchCriteria} from "@ots-frontend/ots-data";

type RestrictionUIState = {
  searchFilter?: RestrictionSearchCriteria
}

const INITIAL_STATE: Readonly<RestrictionUIState> = {};

const restrictionUISlice = createSlice({
  name: "ots-ui/restriction",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIRestrictionSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const restrictionUIReducer = restrictionUISlice.reducer;
